<template>
    <div>
        <b-modal ref="myModal" centered @hide="onHide()">
            <template slot="modal-title">
                <p>{{action}} a {{status}} {{origin}}</p>
            </template>

            <b-form-group>
                <b-form-radio-group v-model="selected">
                    <b-form-radio value="default">Default values</b-form-radio>
                    <b-form-radio value="parameters">With actual parameters</b-form-radio>
                </b-form-radio-group>
            </b-form-group>

            <b-tabs v-if="action === 'Embed'" v-model="tabIndex">
                <b-tab title="Embed code" active>
                    <input-component :link="codeToEmbed" :copied="copied" @copyLink="copyLink()"></input-component>
                </b-tab>
                <b-tab title="Embed url">
                    <input-component :link="link" :copied="copied" @copyLink="copyLink()"></input-component>
                </b-tab>
            </b-tabs>
            <input-component v-else :link="link" :copied="copied" @copyLink="copyLink()"></input-component>

            <div v-if="status === 'private' && action === 'Share' && origin === 'report'" class="mt-3 text-left text-small">
                <div class="mb-3">
                    Your report is private, you can set set a secret word to unlock the report without create a new user.
                </div>
                <b-button variant="danger"  @click="secretWord = !secretWord" class="mb-4">
                    Set a secret word
                </b-button>
            </div>


            <span v-if="message">Secret word saved successfully</span>

            <b-input-group v-if="secretWord" class="mb-1">
                <b-form-input v-model="report.secretWord"
                              type="text"
                              placeholder="Secret word">
                </b-form-input>
                <b-input-group-append>
                    <b-btn variant="success" @click.prevent="saveReport()">Save</b-btn>
                </b-input-group-append>
            </b-input-group>

            <template slot="modal-footer" class="pt-0">
                <b-button variant="primary" @click="hide()">Done</b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import InputComponent from './InputShareModal.vue';
    import {mapState} from 'vuex';

    export default {
        props: ['status', 'origin', 'baseUrl', 'id', 'action'],
        data() {
            return {
                selected: '',
                link: '',
                parameters: [],
                word: '',
                secretWord: false,
                message: false,
                copied: false,
                tabIndex: 3,
                width: 400,
                heigth: 400,
                codeToEmbed: ''
            }
        },
        components: {
            InputComponent
        },
        created() {
            this.tabIndex = 0;
            this.selected = 'default';
        },
        computed: {
            ...mapState('reports', {
                reportParameters: 'parameters',
                report: 'report'
            }),
            ...mapState('visualizations', {
                visualizationParameters: 'parameters'
            })
        },
        methods: {
            show() {
                this.$refs.myModal.show();
            },
            hide() {
                this.$refs.myModal.hide();
            },
            onHide() {
                this.secretWord = false;
                this.message = false;
                this.copied = false;
            },
            parametersList() {
                let list = '';
                if (this.origin === 'report') {
                    this.parameters = this.reportParameters;
                } else {
                    this.parameters = this.visualizationParameters;
                }
                if (this.parameters.length !== 0) {
                    list = `?${this.parameters[0].name}=${this.parameters[0].default}`;
                    if (this.parameters.length > 1) {
                        for (let index = 1; index < this.parameters.length; index++) {
                            list = `${list}&${this.parameters[index].name}=${this.parameters[index].default}`;
                        }
                    }
                }
                return list;
            },
            checkType(link, type) {
                return new Promise(resolve => {
                    if (type === 'parameters') {
                        let parametersList = this.parametersList();
                        this.link = `${link}${parametersList}`
                    }
                    resolve();
                })
            },
            copyLink() {
                this.$clipboard();
                if (this.action === 'Embed' && this.tabIndex === 0) {
                    this.$clipboard(this.codeToEmbed);
                } else {
                    this.$clipboard(this.link);
                }
                this.copied = true;
            },
            saveReport() {
                this.$store.dispatch('reports/update', this.id).then(() => {
                    this.secretWord = false;
                    this.message = true;
                });
            },
            setBaseLink() {
                return new Promise(resolve => {
                    if (this.action === 'Share') {
                        this.link = `${this.baseUrl}/#/${this.origin}/${this.id}`;
                    } else {
                        this.link = `${this.baseUrl}/#/${this.origin}/embed/${this.id}`;
                    }
                    resolve();
                });
            },
            embedCode(link, index) {
                if (index === 0) {
                    this.codeToEmbed = `<iframe width="${this.width}" height="${this.heigth}" src="${link}" frameborder="0" style="border:0" allowfullscreen></iframe>`
                }
            },
            generateLink() {
                this.setBaseLink().then(() => {
                    this.checkType(this.link, this.selected).then(() => {
                        if (this.action === 'Embed') {
                            this.embedCode(this.link, this.tabIndex)
                        }
                    })
                });
            }
        },
        watch: {
            selected(selected) {
                this.copied = false;
                this.selected = selected;
                this.generateLink();
            },
            action(action) {
                this.secretWord = false;
                this.copied = false;
                this.generateLink();
            },
            tabIndex(index) {
                this.copied = false;
                if (this.action === 'Embed') {
                    this.embedCode(this.link, index);
                }
            }
        },
    }
</script>

<style scoped>
    .modal-header {
        padding-bottom: 0;
    }

    ul.nav.nav-tabs {
        margin-bottom: 0px;
    }
</style>

